import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

export const OpenIQPersona1Icon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 48 48">
    <circle cx="24" cy="24" r="24" fill="#EEECEB" />
    <circle cx="26.5" cy="16.5" r="14.5" fill="#0C0B5A" />
    <path
      d="M36.5527 33C39.7259 33 42.8064 33.4022 45.75 34.1543C41.9251 42.333 33.6252 48 24 48C18.9409 48 14.2489 46.4325 10.3789 43.7598C17.1535 37.0998 26.3811 33 36.5527 33Z"
      fill="#00B866"
    />
    <path
      d="M26.6191 15.7666V20.1689H27.6582C27.8906 18.7434 29.1279 17.6553 30.6191 17.6553C31.5916 17.6553 32.4538 18.1197 33.002 18.8369C33.3878 19.3417 33.6191 19.9709 33.6191 20.6553C33.6191 21.3407 33.3868 21.9704 33 22.4756V22.4795C32.6122 22.9837 32.0671 23.3608 31.4385 23.5391L33 26.2432V37.6553C33 39.3121 30.3137 40.6553 27 40.6553C23.6863 40.6553 21 39.3121 21 37.6553V32C17.6863 32 15 29.1594 15 25.6553V17.6553C15 15.9517 15.4726 14.3582 16.2949 13L26.6191 15.7666Z"
      fill="#F0B824"
    />
    <path d="M21 32H29L21 38V32Z" fill="#CA9B1E" />
  </SvgIcon>
);
